import React, { useState } from 'react'
import styles from '../../UpdateSiteModal.module.css'
import { AccessOption, Toggle } from '../AccessSettings/AccessToggle'
import useCheckScreenSize from 'hooks/checkMobileScreen'

const COMMENTS_GIF_DISMISSED_KEY = 'commentsPreviewGifDismissed'

const EnableCommentsSection = ({ toggleValues, setFieldValue, uploadValues, site }) => {
  const { isMobile } = useCheckScreenSize()

  // Persist the user's choice so the preview GIF stays hidden across sessions.
  const [isGifDismissed, setIsGifDismissed] = useState(() => {
    try {
      return localStorage.getItem(COMMENTS_GIF_DISMISSED_KEY) === 'true'
    } catch {
      return false
    }
  })

  const handleDismissGif = () => {
    try {
      localStorage.setItem(COMMENTS_GIF_DISMISSED_KEY, 'true')
    } catch {
      // Ignore storage errors (e.g. disabled storage) and still hide the GIF for this session.
    }
    setIsGifDismissed(true)
  }

  const handleToggleChange = (e) => {
    setFieldValue('toggleValues.feedbackMode', e.target.checked)
  }

  if (!uploadValues?.selectedFile && !site?.isTransferRequestLink) {
    return null
  }

  return (
    <div id="enable_comments" className={`${styles.section} ${styles.commentsSection}`}>
      <span className={styles.sectionTitle}>
        <img src="/assets/icons/feedback-comment.svg" alt="comments" height="24" width="24" className="op-6" />
        <h3 className="mb-0 font-18">Comments & feedback</h3>
      </span>

      <AccessOption
        iconClass="feedbackIcon"
        iconSrc="/assets/icons/feedback-comment.svg"
        title="Enable Comments"
        description="Allow visitors to leave feedback through comments"
        control={
          <div className={styles.optionToggle}>
            <Toggle
              className="tr-comments"
              checked={toggleValues?.feedbackMode}
              onChange={handleToggleChange}
              id="feedbackModeToggle"
              ariaLabel="Toggle feedback mode"
              dataTestId="AccessOption-input-enable-comments"
            />
          </div>
        }
      />

      {!toggleValues?.feedbackMode && !isGifDismissed && !isMobile && (
        <div className={styles.previewContainer}>
          <div
            className={styles.commentsGifWrapper}
            onClick={handleDismissGif}
            role="button"
            tabIndex={0}
            aria-label="Dismiss comments preview"
            data-testid="EnableComments-dismiss-gif"
          >
            <img src="/assets/img/gifs/feedback.gif" alt="Comments preview" className={styles.commentsGif} />
            <div className={styles.dismissGifOverlay}>
              <span className={styles.dismissGifText}>Dismiss</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EnableCommentsSection
